<template>
  <v-sheet :class="$vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'">
    <v-card-text class="trade">
      <div class="icon-wrapper-body">
        <div class="icon-wrapper">
          <div class="icon-box">
            <slot name="icon">
              <!-- paste Clients svg here -->
            </slot>
          </div>

          <div class="icon-content">
            <h3>Clients</h3>
            <span>Account</span>
          </div>
        </div>

        <div class="badgeClass icon-badge">
          <i>+1 new</i>
        </div>
      </div>

      <p class="amount">
        <span v-if="dashboardTotalUsers">
          <countTo :startVal="startVal" :endVal="parseAmount(dashboardTotalUsers)" :duration="3000" />
        </span>
        <span v-else>0</span>

        <router-link class="links" to="/registered-user">See All</router-link>
      </p>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { REGISTEREDUSER__ACTIONS } from "@/store/action-types";
import countTo from "vue-count-to";
import { parseAmount } from "./utils";

export default {
  components: { countTo },
  data: () => ({ startVal: 0 }),
  computed: {
    ...mapState("registeredUser", ["dashboardTotalUsers"]),
  },
  methods: {
    ...mapActions("registeredUser", [REGISTEREDUSER__ACTIONS.DASHBOARDTOTALUSERS]),
    parseAmount,
  },
  async created() {
    await this[REGISTEREDUSER__ACTIONS.DASHBOARDTOTALUSERS]();
  },
};
</script>
